import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Catering from "./pages/Catering";
import EventPlanning from "./pages/EventPlanning";
import EventTypes from "./pages/EventTypes";
import Decorations from "./pages/Decorations";
import Gallery from "./pages/Gallery";
import SocialMedia from "./pages/SocialMedia";
import QRCode from "./pages/QRCode";
import Contact from "./pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/catering" element={<Catering />} />
          <Route path="/events" element={<EventPlanning />} />
          <Route path="/event-types" element={<EventTypes />} />
          <Route path="/decorations" element={<Decorations />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/social" element={<SocialMedia />} />
          <Route path="/qr-code" element={<QRCode />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;